import * as React from "react";
import styled from "styled-components";

import { colors } from "../../design";
import Button from "../atoms/Button";
import Input from "../atoms/Input";

interface IProps {
  searchText: string;
  onChange: (text: string) => void;
  clearSearchBox: () => void;
}

const SearchBox: React.FC<IProps> = ({
  searchText,
  onChange,
  clearSearchBox,
  ...props
}) => {
  return (
    <OutWrapper {...props}>
      <InnerWrapper>
        <GrassIcon className="fas fa-search" />
        <SearchBoxInput
          type="text"
          value={searchText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.value)
          }
        />
        {searchText ? (
          <CancelButton
            // 行けてないのので　clear method 作る
            onClick={clearSearchBox}
            title={"キャンセル"}
          />
        ) : null}
      </InnerWrapper>
    </OutWrapper>
  );
};

export default SearchBox;

const OutWrapper = styled.div`
  background-color: #f7f7f7;
  padding-top: 8px;
  height: 46px;
`;

const InnerWrapper = styled.div`
  display: flex;
  position: relative;
  max-width: 600px;
  margin: 0 auto;
`;

const GrassIcon = styled.div`
  position: absolute;
  top: 10px;
  left: 12px;
  font-size: 0.8rem;
`;

const CancelButton = styled(Button)`
  display: block;
  width: 100px;
  font-size: 0.8rem;
  background-color: ${colors.darkGray};
  margin-left: 4px;
  text-align: center;
  color: #fff;
  line-height: 28px;
  border-radius: 3px;
  cursor: pointer;
  height: 28px;
`;

const SearchBoxInput = styled(Input)`
  color: ${colors.darkGray};
  border: 1px solid #ddd;
  padding: 6px 8px 5px 32px;
  font-size: 0.9rem;
  outline: none;
  width: 100%;
  border-radius: 3px;
  height: 28px;
`;
